<template>
  <div>
    <b-container id="nomalInfoContainer">
      <b-row style="height: 30px;">
        <b-col class="title">{{InvitationPageInfo.ProviderName}}</b-col>
      </b-row>
      <b-row style="height:60%;">
        <b-col style="text-align:center;">
          <QRCode :URL="InvitationPageInfo.QRCodeLink" :QRCodeWidth="150"></QRCode>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="pd0">
      <b-row>
        <b-col cols="8">現在選擇：{{this.choisePhoneNumberMask}}</b-col>
        <b-col cols="4" style="text-align:end;">{{InvitationPageInfo.Code}}</b-col>
      </b-row>
      <b-row>
        <b-col style="padding-bottom: 10px;">
          <b-card no-body header-bg-variant="danger" header-text-variant="white" header="傳送號碼">
            <b-list-group flush>
              <b-list-group-item v-if="InvitationPageInfo.PhoneNumberMask != null">
                <b-container style="padding:0;">
                  <b-row>
                    <b-col cols="5">手機號碼：</b-col>
                    <b-col cols="4" class="padding-left-0">{{InvitationPageInfo.PhoneNumberMask}}</b-col>
                    <b-col cols="3" class="padding-left-0">
                      <b-button
                        variant="danger"
                        @click="setPhoneNumber(InvitationPageInfo.PhoneNumber,InvitationPageInfo.PhoneNumberMask)"
                        class="btn chose"
                      >選擇</b-button>
                    </b-col>
                  </b-row>
                </b-container>
              </b-list-group-item>
              <b-list-group-item v-if="InvitationPageInfo.AttorneyPhoneMask != null">
                <b-container style="padding:0;">
                  <b-row>
                    <b-col cols="5">法定代理人：</b-col>
                    <b-col cols="4" class="padding-left-0">{{InvitationPageInfo.AttorneyPhoneMask}}</b-col>
                    <b-col cols="3" class="padding-left-0">
                      <b-button
                        variant="danger"
                        @click="setPhoneNumber(InvitationPageInfo.AttorneyPhone,InvitationPageInfo.AttorneyPhoneMask)"
                        class="btn chose"
                      >選擇</b-button>
                    </b-col>
                  </b-row>
                </b-container>
              </b-list-group-item>
              <b-list-group-item v-if="InvitationPageInfo.OtherPhoneMask != null" button>
                <b-row>
                  <b-col cols="5">其他手機:</b-col>
                  <b-col cols="4" class="padding-left-0">{{InvitationPageInfo.OtherPhoneMask}}</b-col>
                  <b-col cols="3" class="padding-left-0">
                    <b-button
                      variant="danger"
                      @click="setPhoneNumber(InvitationPageInfo.OtherPhone,InvitationPageInfo.OtherPhoneMask)"
                      class="btn chose"
                    >選擇</b-button>
                  </b-col>
                </b-row>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col style="text-align:center;">
          <b-button variant="danger" @click="sendSMS()">發送SMS</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import QRCode from "../Main/QRCode.vue";
import { SMSHandler } from "@/handler/SMSHandler.js";
import { Loading } from "element-ui";
export default {
  props: ["InvitationPageInfo", "leadSn", "tutorChatToken"],
  data() {
    return {
      choisePhoneNumber: "",
      choisePhoneNumberMask: ""
    };
  },
  components: {
    QRCode
  },
  methods: {
    setPhoneNumber: function(phoneNumber, phoneNumberMask) {
      this.choisePhoneNumber = phoneNumber;
      this.choisePhoneNumberMask = phoneNumberMask;
    },
    sendSMS: function() {
      if (this.choisePhoneNumber == "") {
        alert("您尚未選擇電話號碼。");
        return;
      }
      let loadingInstance = Loading.service({ fullscreen: true });
      var result = SMSHandler.sendInvitationSMS(
        this.leadSn,
        this.tutorChatToken,
        this.InvitationPageInfo.SocialNetWorkProviderId,
        this.choisePhoneNumber,
        this.InvitationPageInfo.QRCodeLink
      );
      loadingInstance.close();
      if (result) {
        alert("專屬邀請函已發送成功。");
      } else {
        alert("請勿短時間重複發送專屬邀請函。");
      }
    }
  }
};
</script>

<style scoped>
#nomalInfoContainer {
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  font-size: 13px;
  padding: 10px 15px;
}
.pd0 {
  padding: 0;
  font-size: 15px;
  margin-top: 20px;
}
.btn {
  font-size: 15px;
  background: #b20404;
  margin-top: 15px;
}

.chose {
  font-size: 13px;
  margin-top: 0;
  padding: 0.375rem 10px;
}

.card {
  font-size: 13px;
  margin-top: 15px;
}

.card-header {
  background: #989898 !important;
  padding: 10px 15px;
}

.list-group-item {
  padding: 10px 15px;
}

.title {
  text-align: center;
}

.list-group-item .row .col-4,
.list-group-item .row .col-5 {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.padding-left-0 {
  padding-left: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/InvitationPage.vue